import React, { useState } from "react";
import styles from "./style.module.scss";
import { QuestionCircleFill } from "react-bootstrap-icons";
// import { Tooltip } from "react-bootstrap";

const ToolTip = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (props.showOnHover) {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (props.showOnHover) {
      setIsVisible(false);
    }
  };

  const handleFocus = () => {
    if (props.showOnFocus) {
      setIsVisible(true);
    }
  };

  const handleBlur = () => {
    if (props.showOnFocus) {
      setIsVisible(false);
    }
  };

  return (
    <span 
      className={styles.toolTipContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <QuestionCircleFill size={18} />
      <span className={`${styles.toolTipBox} ${isVisible ? styles.visible : ''}`}>
        {props.tooltipText || "Please contact Canco support to update your email"}
      </span>
    </span>
  );
};

export default ToolTip;
